// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__2ne_n","removeButton":"styles_removeButton__2A5ir"};